import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const inventoryOpeningBalanceService = createApi({
  reducerPath: "inventoryOpeningBalanceService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["inventoryOpeningBalance"],
  endpoints: (builder) => ({
    // ✅ Get All with Pagination
    getAllInventoryOpeningBalance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.getAllInventoryOpeningBalanceWithPagination}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Search
    searchInventoryOpeningBalance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.searchInventoryOpeningBalance}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Save
    saveInventoryOpeningBalance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.saveInventoryOpeningBalance}`,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Update
    updateInventoryOpeningBalance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.updateInventoryOpeningBalance}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Delete
    deleteInventoryOpeningBalance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.deleteInventoryOpeningBalance}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Get by ID
    getInventoryOpeningBalanceById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.getInventoryOpeningBalanceById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Get All without pagination
    findAllInventoryOpeningBalance: builder.mutation({
      query: (body) => ({
        url: `${userManagement.inventoryOpeningBalanceController.getAllInventoryOpeningBalance}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    // ✅ Bulk Upload
    bulkUploadInventoryOpeningBalance: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.inventoryOpeningBalanceController.bulkUploadInventoryOpeningBalance}`,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});

export const {
  useGetAllInventoryOpeningBalanceMutation,
  useSearchInventoryOpeningBalanceMutation,
  useSaveInventoryOpeningBalanceMutation,
  useUpdateInventoryOpeningBalanceMutation,
  useDeleteInventoryOpeningBalanceMutation,
  useGetInventoryOpeningBalanceByIdMutation,
  useFindAllInventoryOpeningBalanceMutation,
  useBulkUploadInventoryOpeningBalanceMutation,
} = inventoryOpeningBalanceService;
